<!-- eslint-disable vue/multi-word-component-names -->
<!-- Markup generated verbatim from the-dream-international.html (page "support"). -->
<template>
<div class="page" data-page="support">
  <section class="phero">
    <div class="corner" aria-hidden="true"><svg viewBox="96 123 492 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="The Dream International"><path class="lg-gold" d="M 107.8 282.2 L 103.7 356.6 L 251.6 354 L 126.9 467.6 L 183.5 521.5 L 346.2 362.6 L 410.2 360.6 L 412.2 291.1 Z M 107.8 282.2"/><path class="lg-navy" d="M 412.9 272.6 L 428.1 130.1 L 428.2 129.4 L 353 129 L 345.9 270 Z M 412.9 272.6"/><path class="lg-navy" d="M 325.5 269.5 L 228.9 149.2 L 175.3 198.7 L 247 267.5 Z M 325.5 269.5"/><path class="lg-navy" d="M 432.9 275.7 L 431.2 352.6 L 550.9 265.7 L 505.5 210.1 Z M 432.9 275.7"/><path class="lg-gold" d="M 573.9 355.5 L 269.3 365.1 L 276 574.5 L 348.3 567.5 L 337.3 456.6 L 457.2 552.2 L 501.5 504 L 398.1 422.9 L 580.2 425.9 Z M 573.9 355.5"/></svg></div>
    <div class="wrap">
      <span class="eyebrow"><span class="dot"></span>Get involved</span>
      <h1>Be the bridge to a dream.</h1>
      <p class="lede">Volunteers teach every class, and donors cover much of everything else. Choose the way that fits you.</p>
      <div class="cta-row"><router-link class="btn btn-primary" to="/support#give">Give</router-link><router-link class="btn btn-ghost" to="/support#teach">Teach</router-link><router-link class="btn btn-ghost" to="/support#partner">Partner</router-link></div>
    </div>
  </section>

  <section class="block" id="give">
    <div class="wrap give">
      <div class="stack" style="gap:22px">
        <span class="eyebrow"><span class="dot"></span>Give</span>
        <h2>Your gift keeps classes within reach.</h2>
        <p class="lede">We run lean. Teachers volunteer their time, so donations go to the work around the classroom.</p>
        <ul class="uses">
          <li><div><b>Dreamers Blessing</b><br>Our teams travel to meet students in person, celebrate what they have learned in class and serve their local communities alongside our branches.</div></li>
          <li><div><b>Teacher Training</b><br>Preparation before each season and support while it runs.</div></li>
          <li><div><b>The Learning Platform</b><br>The tools that match students with teachers and keep classes running.</div></li>
        </ul>
      </div>
      <div class="pay">
        <h3>Ways to give</h3>
        <div class="payrow"><div><div class="lbl">Zelle</div><div class="val" id="zelle">finance@thedreaminc.org</div></div><button class="copy" type="button" @click="copy('zelle')">Copy</button></div>
        <div class="payrow"><div><div class="lbl">PayPal</div><div class="val">The Dream Inc.</div></div><button class="copy" type="button" @click="openPaypal">Donate</button></div>
        <p class="taxnote">The Dream Inc. is exempt from federal income tax under Section 501(c)(3) of the Internal Revenue Code (EIN 30-1295205). Contributions are tax-deductible to the extent allowed by law. No goods or services are provided in exchange for your donation.</p>
      </div>
    </div>
  </section>

  <section class="block alt" id="teach">
    <div class="wrap split">
      <div class="stack" style="gap:22px">
        <span class="eyebrow"><span class="dot"></span>Teach</span>
        <h2>Share what you know, one student at a time.</h2>
        <p class="lede">English, computer skills or Korean. You teach from home, on a schedule you agree with your student.</p>
      </div>
      <div class="stack" style="gap:22px">
        <ul class="uses">
          <li><div><b>A Real Relationship</b><br>One student for the whole season, so you see their progress week by week.</div></li>
          <li><div><b>Training and Support</b><br>We prepare you before the season starts and stay with you through it.</div></li>
          <li><div><b>A Community of Volunteers</b><br>Appreciation Day, season recaps and gatherings with teachers across the United States.</div></li>
        </ul>
        <div class="payrow"><div><div class="lbl">Write to us to apply</div><div class="val" id="adminmail">admin@thedreaminc.org</div></div><button class="copy" type="button" @click="copy('adminmail')">Copy</button></div>
      </div>
    </div>
  </section>

  <section class="block" id="partner">
    <div class="wrap split">
      <div class="stack" style="gap:22px">
        <span class="eyebrow"><span class="dot"></span>Partner</span>
        <h2>Bring The Dream to your community.</h2>
      </div>
      <div class="prose">
        <p>Our students join through referral partners, the organizations that know them best. Partners share referral codes with students, help recruit volunteer teachers, and stay close to the people we serve.</p>
        <p>If your organization works with students in North Africa, the Middle East or beyond, we would love to talk.</p>
        <router-link class="link" to="/faq" style="align-self:flex-start">Read the FAQ</router-link>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import { SITE } from '@/data/site';
import { openLogin } from '@/composables/useLogin';
import { copyText } from '@/composables/useToast';

export default {
  name: 'SupportUs',
  methods: {
    openLogin,
    openPaypal() {
      window.open(SITE.paypalDonateUrl, '_blank', 'noopener');
    },
    copy(key) {
      copyText(SITE.copyValues[key], this.$el.querySelector('#' + key));
    },
  },
};
</script>
